module.exports = __webpack_public_path__ + "img/Printer Icon - white.5486e1de.svg";